/* Sobczyk Barista giveaway landing · anchors, sticky bar, lazy video, Klaviyo embed relabel + success state */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.sbbReady) return;
    root.dataset.sbbReady = '1';
    initAnchors(root);
    initSticky(root);
    initVideo(root);
    initSlider(root);
    initKlaviyo(root);
  }

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* ---------- anchors ---------- */
  function initAnchors(root) {
    root.addEventListener('click', function (e) {
      var a = e.target.closest('[data-sbb-anchor]');
      if (!a) return;
      var id = (a.getAttribute('href') || '').replace('#', '');
      var target = id && document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      if (target.tagName === 'SECTION' && target.querySelector('details')) target.querySelector('details').open = true;
      target.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'start' });
      var input = target.querySelector('input[type="text"], input[type="email"]');
      if (input) setTimeout(function () { input.focus({ preventScroll: true }); }, reducedMotion() ? 0 : 500);
    });
  }

  /* ---------- sticky bar (mobile) ---------- */
  function initSticky(root) {
    var bar = root.querySelector('[data-sbb-sticky]');
    var hero = root.querySelector('[data-sbb-hero]');
    var formSection = root.querySelector('[data-sbb-form-section]');
    if (!bar || !hero || !('IntersectionObserver' in window)) return;
    var heroPassed = false;
    var formVisible = false;
    var signedUp = false;
    function update() {
      var show = heroPassed && !formVisible && !signedUp;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      bar.querySelector('a').tabIndex = show ? 0 : -1;
    }
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { heroPassed = !en.isIntersecting && en.boundingClientRect.bottom < 0; });
      update();
    }, { threshold: 0 }).observe(hero);
    if (formSection) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { formVisible = en.isIntersecting; });
        update();
      }, { threshold: 0.2 }).observe(formSection);
    }
    root.addEventListener('sbb:signedup', function () { signedUp = true; update(); });
  }

  /* ---------- video: lazy, muted autoplay loop; sound button unmutes and restarts ---------- */
  function initVideo(root) {
    var wrap = root.querySelector('[data-sbb-video]');
    var video = wrap && wrap.querySelector('video');
    var sound = wrap && wrap.querySelector('[data-sbb-sound]');
    if (!video) return;
    var src = video.getAttribute('data-src');
    if (!src) return;
    var loaded = false;
    function load() {
      if (loaded) return;
      loaded = true;
      video.src = src;
      video.load();
      video.addEventListener('playing', function () { wrap.classList.add('is-playing'); });
    }
    function autoplay() {
      load();
      var p = video.play();
      if (p && p.catch) p.catch(function () { /* autoplay blocked: poster stays until the user taps */ });
    }
    if (!reducedMotion()) {
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries, obs) {
          entries.forEach(function (en) { if (en.isIntersecting) { autoplay(); obs.disconnect(); } });
        }, { rootMargin: '300px 0px' }).observe(wrap);
      } else {
        autoplay();
      }
    }
    if (sound) {
      var label = sound.querySelector('[data-sbb-sound-label]');
      function setState(on) {
        sound.setAttribute('aria-pressed', on ? 'true' : 'false');
        wrap.classList.toggle('has-sound', on);
        if (label) label.textContent = sound.getAttribute(on ? 'data-label-off' : 'data-label-on');
      }
      sound.addEventListener('click', function () {
        load();
        if (video.muted) {
          video.muted = false;
          video.currentTime = 0;
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
          setState(true);
        } else {
          video.muted = true;
          setState(false);
        }
      });
      /* leaving the panel: back to silent so the loop never blares off-screen */
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (!en.isIntersecting && !video.muted) { video.muted = true; setState(false); }
          });
        }, { threshold: 0.2 }).observe(wrap);
      }
    }
  }

  /* ---------- hero slider: scroll-snap track, dots, auto-advance, pauses on touch/hover ---------- */
  function initSlider(root) {
    var slider = root.querySelector('[data-sbb-slider]');
    if (!slider || !slider.classList.contains('sbb-slider--multi')) return;
    var track = slider.querySelector('[data-sbb-track]');
    var slides = [].slice.call(slider.querySelectorAll('[data-sbb-slide]'));
    var dots = [].slice.call(slider.querySelectorAll('[data-sbb-dot]'));
    var index = 0;
    var timer = null;
    var interval = (parseInt(slider.getAttribute('data-interval'), 10) || 5) * 1000;

    function setActive(i) {
      index = (i + slides.length) % slides.length;
      dots.forEach(function (d, j) {
        d.classList.toggle('is-active', j === index);
        d.setAttribute('aria-selected', j === index ? 'true' : 'false');
      });
    }
    function goTo(i, smooth) {
      setActive(i);
      track.scrollTo({ left: slides[index].offsetLeft, behavior: smooth && !reducedMotion() ? 'smooth' : 'auto' });
    }
    function start() { stop(); if (!reducedMotion()) timer = setInterval(function () { goTo(index + 1, true); }, interval); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    dots.forEach(function (d) {
      d.addEventListener('click', function () { goTo(parseInt(d.getAttribute('data-sbb-dot'), 10), true); start(); });
    });
    var scrollT = null;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollT);
      scrollT = setTimeout(function () {
        var w = track.clientWidth || 1;
        setActive(Math.round(track.scrollLeft / w));
      }, 80);
    }, { passive: true });
    ['touchstart', 'pointerdown', 'mouseenter'].forEach(function (ev) { slider.addEventListener(ev, stop, { passive: true }); });
    ['touchend', 'pointerup', 'mouseleave'].forEach(function (ev) { slider.addEventListener(ev, start, { passive: true }); });
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
    start();
  }

  /* ---------- Klaviyo embed: relabel to the design, swap to success card on submit ---------- */
  function initKlaviyo(root) {
    var host = root.querySelector('.sbb-klaviyo');
    var formWrap = root.querySelector('[data-sbb-form]');
    var template = root.querySelector('template.sbb-success-template');
    if (!host || !formWrap || !template) return;

    var formId = host.getAttribute('data-form-id');
    var labels = {
      submit: host.getAttribute('data-submit-label'),
      first: host.getAttribute('data-label-first-name'),
      firstPh: host.getAttribute('data-placeholder-first-name'),
      email: host.getAttribute('data-label-email'),
      emailPh: host.getAttribute('data-placeholder-email')
    };

    function setText(el, text) { if (el && text && el.textContent.trim() !== text) el.textContent = text; }
    function setPh(input, text) { if (input && text && input.getAttribute('placeholder') !== text) input.setAttribute('placeholder', text); }
    function labelFor(input) {
      return host.querySelector('label[for="' + input.id + '"]') || (input.parentElement && input.parentElement.querySelector('label'));
    }
    function relabel() {
      host.querySelectorAll('button').forEach(function (b) { setText(b.querySelector('span') || b, labels.submit); });
      var email = host.querySelector('input[type="email"]');
      var name = host.querySelector('input[type="text"]');
      if (email) { setText(labelFor(email), labels.email); setPh(email, labels.emailPh); }
      if (name) { setText(labelFor(name), labels.first); setPh(name, labels.firstPh); }
    }
    new MutationObserver(relabel).observe(host, { childList: true, subtree: true });
    relabel();

    function showSuccess() {
      if (formWrap.querySelector('.sbb-success')) return;
      var card = template.content.cloneNode(true);
      formWrap.innerHTML = '';
      formWrap.appendChild(card);
      formWrap.classList.add('is-success');
      root.dispatchEvent(new CustomEvent('sbb:signedup', { bubbles: true }));
    }

    window.addEventListener('klaviyoForms', function (event) {
      var d = event.detail || {};
      if (d.type !== 'submit') return;
      if (formId && d.formId && d.formId !== formId) return;
      remember();
      showSuccess();
    });

    /* Already signed up: Meta lead form completion URL (…#success or ?success=1) or remembered on this device.
       Same pattern as the Tomi Boon Nam page. */
    var KEY = 'sbb:barista:signed-up';
    function remember() { try { window.localStorage.setItem(KEY, '1'); } catch (e) { /* storage blocked */ } }
    function remembered() { try { return window.localStorage.getItem(KEY) === '1'; } catch (e) { return false; } }
    /* …#success or ?success=1 → success state (Meta lead completion, mails to people already on the list).
       Combine with a section anchor to land elsewhere, e.g. …/pages/barista?success=1#maskinen → video. */
    var params = new URLSearchParams(window.location.search);
    var viaUrl = window.location.hash === '#success' || params.has('success');
    if (viaUrl || remembered()) {
      if (viaUrl) remember();
      showSuccess();
      if (window.location.hash === '#success') {
        var section = root.querySelector('[data-sbb-form-section]');
        if (section) setTimeout(function () { section.scrollIntoView({ behavior: 'auto', block: 'start' }); }, 50);
      }
    }
    var hashTarget = window.location.hash && window.location.hash !== '#success' && document.getElementById(window.location.hash.slice(1));
    if (hashTarget) setTimeout(function () { hashTarget.scrollIntoView({ behavior: 'auto', block: 'start' }); }, 150);
  }

  function boot() { document.querySelectorAll('.sbb').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
